import { lazy } from "react";
import { Route } from "../../RouteModel";

const CashManagementAccountEdit = lazy(
  () =>
    import(
      "../../../pages/configuration/customers/cash-management/account/Edit"
    )
);

const AccountDetails = lazy(
  () =>
    import(
      "../../../pages/configuration/customers/cash-management/account/Details"
    )
);

const CashManagementAccountCreate = lazy(
  () =>
    import(
      "../../../pages/configuration/customers/cash-management/account/Create"
    )
);

export const cashManagementAccountRoutes: Route[] = [
  {
    i18nName: "Edit account - Cash management",
    path: "/configuration/customers/:id/cash-management/account/create",
    component: CashManagementAccountCreate,
  },
  {
    i18nName: "Edit account - Cash management",
    path: "/configuration/customers/:id/cash-management/account/:accountId",
    component: AccountDetails,
  },
  {
    i18nName: "Account details - Cash management",
    path:
      "/configuration/customers/:id/cash-management/account/:accountId/edit",
    component: CashManagementAccountEdit,
  },
];
